
class CardProductMixedStyles extends HTMLElement {
  constructor() {
    super();
    this.item = undefined;

    this.wrapper = undefined;
    this.img = undefined;
    this.heading = undefined;
    this.color = undefined;
    this.size = undefined;
    this.condition = undefined;
    this.price = undefined;
  }

  assignElements() {
    this.wrapper = this.querySelector('.product-mixed-card__wrapper');
    this.img = this.querySelector('img');
    this.heading = this.querySelector('.card__heading');
    this.color = this.querySelector('.card__subfield-color');
    this.size = this.querySelector('.card__subfield-size');
    this.condition = this.querySelector('.card__subfield-condition');
    this.price = this.querySelector('.card__price .price-item');
  }

  populateElements() {
    const imgUrl = (this.item.images.length >= 1) ? this.item.images[0].url : localStorage.getItem('cameraShyImageUrl');
    this.img.setAttribute('src', normalizeUrl(imgUrl, {width: '300', height: '300'}));
    this.img.setAttribute('alt', `${this.item.sku}`);
    this.heading.innerText = `${this.item.sku}`;
    this.color.innerText = `${this.item.color.display}`;
    this.size.innerText = `${this.item.size.display}`;
    this.condition.innerText = `${this.item.condition.display}`;
    this.price.innerText = formatMoney(this.item.price);

    // Status options: 'available', 'inCart' (for other carts), and 'inUsersCart'
    if (this.item.itemStatus == 'inCart') {
      this.wrapper.classList.add('item-in-other-cart');
    }
    else if (this.item.itemStatus == 'inUsersCart') {
      this.wrapper.classList.add('item-in-cart');
    }
  }

  addClickEvent() {
    this.addEventListener('click', () => {
      sessionStorage.setItem('selectedMixedStyleItem', JSON.stringify(this.item));
      const mixedStylesEvent = new CustomEvent('mixedstyleitemselected', { detail: this.item });
      document.dispatchEvent(mixedStylesEvent);
    });
  }

  render(item) {
    this.item = item;

    // Append markup from card-product-mixed-styles.liquid to grab custom settings
    this.append(document.getElementById("card-product-mixed-styles").content.cloneNode(true));
    this.setAttribute('id', `card-product-${this.item.uuid}`);
    this.setAttribute('data-trove-uuid', this.item.uuid);
    this.assignElements();
    this.populateElements();
    this.addClickEvent();
  }

  connectedCallback() {}
}

customElements.define('card-product-mixed-styles', CardProductMixedStyles);
